export default __webpack_public_path__ + "static/myhotelcard-logo-0a7870f30841e84bb895cc67f60f737b.png";